import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../components/MasterAdmin/ui/Sidebar';
import Header from '../components/MasterAdmin/ui/Header';
import { getMasterAdminPageTitle } from '../utils/masterAdminPageTitle';
import {
  MasterAdminShellBrandingProvider,
  useMasterAdminShellBranding,
} from '../contexts/MasterAdminShellBrandingContext';
import { recordAdminClientActivity } from '../services/MasterAdmin/EmployeeManagementService';

const MainLayoutInner: React.FC<{ mobileNavOpen: boolean; setMobileNavOpen: (v: boolean) => void }> = ({
  mobileNavOpen,
  setMobileNavOpen,
}) => {
  const location = useLocation();
  const { branding } = useMasterAdminShellBranding();
  const pageTitle = getMasterAdminPageTitle(location.pathname);

  useEffect(() => {
    recordAdminClientActivity({
      action: 'PAGE_VIEW',
      category: 'navigation',
      path: location.pathname,
      pageName: pageTitle || location.pathname,
      performedAction: 'Viewed page',
      summary: `Viewed page — ${pageTitle || location.pathname}`,
    }).catch(() => {
      /* best-effort */
    });
  }, [location.pathname, pageTitle]);

  return (
    <>
      <Sidebar mobileOpen={mobileNavOpen} onCloseMobile={() => setMobileNavOpen(false)} />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <Header
          title={pageTitle}
          shellBranding={branding}
          onOpenMobileNav={() => setMobileNavOpen(true)}
        />
        <main className="min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-hidden px-2 py-2 text-gray-900 dark:text-gray-100 sm:px-4 sm:py-4 md:px-6 md:py-6">
          <Outlet />
        </main>
      </div>
    </>
  );
};

const MainLayout: React.FC = () => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  useEffect(() => {
    if (mobileNavOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileNavOpen]);

  return (
    <MasterAdminShellBrandingProvider>
      <div className="flex h-screen overflow-hidden bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
        <div
          className={`fixed inset-0 z-40 bg-black/50 transition-opacity duration-200 lg:hidden ${
            mobileNavOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
          }`}
          aria-hidden
          onClick={() => setMobileNavOpen(false)}
        />
        <MainLayoutInner mobileNavOpen={mobileNavOpen} setMobileNavOpen={setMobileNavOpen} />
      </div>
    </MasterAdminShellBrandingProvider>
  );
};

export default MainLayout; 